import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { IMarketYoyGrowthCategoryApi } from '../api/types'
import { IMarketYoyGrowthCategory } from '../model/types'

export const mapMarketYoyGrowthCategoryFromApi = (
  data: IMarketYoyGrowthCategoryApi
): IMarketYoyGrowthCategory => ({
  offering: data.Offering as ProgramTypes,
  category: data.Category,
  rtm: data.RTM,
  orderBy: data.OrderBy,
})
